module.exports = __webpack_public_path__ + "img/eu.a65c136b.svg";